/**
 * Маппинг внешних имен иконок на иконки PrimeVue/PrimeIcons
 */
export const iconMapper: Record<string, string> = {
  // Basic actions
  'add': 'pi pi-plus',
  'add-button': 'pi pi-plus',
  'add_page': 'pi pi-file-plus',
  'admin': 'pi pi-wrench',
  'accept': 'pi pi-check',
  'plus': 'pi pi-plus',
  'dots': 'pi pi-ellipsis-h',
  'refresh': 'pi pi-refresh',
  'reload_s': 'pi pi-refresh',
  'save': 'pi pi-save',
  'save-button': 'pi pi-save',
  'save_toolbar_approval': 'pi pi-save',
  'search': 'pi pi-search',
  'search_s': 'pi pi-search',
  'search2': 'pi pi-search',
  'find': 'pi pi-search',
  'find_s': 'pi pi-search',
  'magnifier': 'pi pi-search',
  'star_gray': 'pi pi-star',
  'star': 'pi pi-star',
  'document': 'pi pi-file',
  'document_in': 'pi pi-file-import',
  'document_out': 'pi pi-file-export',
  'directory': 'pi pi-folder',
  'folder': 'pi pi-folder',
  'folder_bullet_minus': 'pi pi-folder-minus',
  'folder_bullet_plus': 'pi pi-folder-plus',
  'box-grey': 'pi pi-box',
  'box': 'pi pi-box',
  'directory_list': 'pi pi-list',
  'tools': 'pi pi-wrench',
  'wrench': 'pi pi-wrench',
  'lightning': 'pi pi-bolt',
  'users': 'pi pi-users',
  'role': 'pi pi-key',
  'key': 'pi pi-key',
  'join-button': 'pi pi-link',
  'arrow_join': 'pi pi-arrows-h',
  'arrow_up': 'pi pi-arrow-up',
  'arrow_down': 'pi pi-arrow-down',
  'arrow_left': 'pi pi-arrow-left',
  'arrow_right': 'pi pi-arrow-right',
  'arrow_bold_left': 'pi pi-angle-double-left',
  'arrow_bold_right': 'pi pi-angle-double-right',
  'arrow_undo': 'pi pi-undo',
  'cnm': 'pi pi-calculator',
  'user_gray': 'pi pi-user',
  'user': 'pi pi-user',
  'page': 'pi pi-file',
  'page_white': 'pi pi-file',
  'page_white_copy': 'pi pi-copy',
  'page_white_error': 'pi pi-exclamation-triangle',
  'page_white_get': 'pi pi-download',
  'page_white_put': 'pi pi-upload',
  'page_add': 'pi pi-file-plus',
  'page_copy': 'pi pi-copy',
  'page_delete': 'pi pi-trash',
  'page_paste': 'pi pi-paste',
  'time': 'pi pi-clock',
  'clock': 'pi pi-clock',
  'clock_1': 'pi pi-clock',
  'email': 'pi pi-envelope',
  'mail': 'pi pi-envelope',
  'mail_add': 'pi pi-envelope-plus',
  'cross': 'pi pi-times',
  'select_all': 'pi pi-check-square',
  'delete': 'pi pi-trash',
  'delete.gif': 'pi pi-trash',
  'delete_s': 'pi pi-trash',
  'delete_page': 'pi pi-file-minus',
  'delete_toolbar_approval': 'pi pi-trash',
  'edit': 'pi pi-pencil',
  'edit.gif': 'pi pi-pencil',
  'edit_s': 'pi pi-pencil',
  'edit-button': 'pi pi-pencil',
  'edit_toolbar_approval': 'pi pi-pencil',
  'edit_address': 'pi pi-map-marker',
  'shading': 'pi pi-th-large',
  'shading.png': 'pi pi-th-large',

  'home': 'pi pi-home',
  'main': 'pi pi-home',
  'house': 'pi pi-home',
  'platform': 'pi pi-cog',
  'cog': 'pi pi-cog',
  'cog_save': 'pi pi-cog',
  'profile': 'pi pi-user',
  'settings': 'pi pi-sliders-h',
  'sliders-h': 'pi pi-sliders-h',
  'file': 'pi pi-file',
  'table': 'pi pi-table',
  'table_edit': 'pi pi-pencil',
  'table_expand': 'pi pi-chevron-down',
  'table_column_auto_resize': 'pi pi-arrows-h',
  'table_refresh': 'pi pi-refresh',
  'table_row_delete': 'pi pi-trash',
  'table_row_insert': 'pi pi-plus',
  'table_gear': 'pi pi-cog',
  'chart': 'pi pi-chart-bar',
  'form': 'pi pi-list',
  'list': 'pi pi-list',
  'print': 'pi pi-print',
  'print_s': 'pi pi-print',
  'printer': 'pi pi-print',
  'download': 'pi pi-download',
  'download-button': 'pi pi-download',
  'upload': 'pi pi-upload',
  'bell': 'pi pi-bell',
  'calendar': 'pi pi-calendar',
  'envelope': 'pi pi-envelope',
  'map': 'pi pi-map',
  'shopping-cart': 'pi pi-shopping-cart',
  'database': 'pi pi-database',
  'server': 'pi pi-server',
  'desktop': 'pi pi-desktop',
  'mobile': 'pi pi-mobile',
  'globe': 'pi pi-globe',
  'lock': 'pi pi-lock',
  'unlock': 'pi pi-unlock',
  'eye': 'pi pi-eye',
  'show': 'pi pi-eye',
  'show.gif': 'pi pi-eye',
  'show_s': 'pi pi-eye',
  'view.gif': 'pi pi-eye',
  'eye-slash': 'pi pi-eye-slash',
  'hide': 'pi pi-eye-slash',
  'hide.png': 'pi pi-eye-slash',
  'filter': 'pi pi-filter',
  'sort': 'pi pi-sort',
  'sort-up': 'pi pi-sort-up',
  'sort-down': 'pi pi-sort-down',

  // Status and indicators
  'information': 'pi pi-info-circle',
  'information-small': 'pi pi-info-circle',
  'info': 'pi pi-info-circle',
  'exclamation': 'pi pi-exclamation-triangle',
  'error': 'pi pi-times-circle',
  'question': 'pi pi-question-circle',
  'check': 'pi pi-check',
  'uncheck': 'pi pi-times',
  'approve': 'pi pi-check',
  'approve2': 'pi pi-check',
  'unapprove2': 'pi pi-times',
  'decline': 'pi pi-times',
  'green_yes': 'pi pi-check-circle',
  'small_green_yes': 'pi pi-check',
  'small_grey_yes': 'pi pi-check',
  'executed': 'pi pi-check-circle',
  'bullet_white': 'pi pi-circle',
  'bullet_green': 'pi pi-circle-fill',
  'bullet_red': 'pi pi-circle-fill',
  'bullet_black': 'pi pi-circle-fill',
  'bullet_blue': 'pi pi-circle-fill',
  'bullet_orange': 'pi pi-circle-fill',
  'bullet_pink': 'pi pi-circle-fill',
  'bullet_purple': 'pi pi-circle-fill',
  'bullet_yellow': 'pi pi-circle-fill',
  'red_circle': 'pi pi-circle-fill',
  'yellow_circle': 'pi pi-circle-fill',

  // Application and windows
  'application': 'pi pi-window-maximize',
  'application_add': 'pi pi-plus',
  'application_save': 'pi pi-save',
  'application_form': 'pi pi-file-edit',
  'application_form_undo': 'pi pi-undo',
  'application_get': 'pi pi-download',
  'application_put': 'pi pi-upload',
  'application_side_list': 'pi pi-list',
  'application_side_tree': 'pi pi-sitemap',
  'application_side_tree_load': 'pi pi-download',
  'application_side_tree_save': 'pi pi-save',
  'application_side_tree_undo': 'pi pi-undo',
  'application_tile_horizontal': 'pi pi-th-large',
  'application_tile_vertical': 'pi pi-th-large',
  'application_xp': 'pi pi-window-maximize',

  // Approval and workflow
  'approval_collapse_button': 'pi pi-chevron-down',
  'approval_expand_button': 'pi pi-chevron-right',
  'agreement_collapse_button': 'pi pi-chevron-down',
  'nested_approval': 'pi pi-sitemap',
  'nested_approval_menu': 'pi pi-sitemap',
  'new_toolbar_approval': 'pi pi-plus',
  'thumb_toolbar_approval': 'pi pi-thumbs-up',
  'toapprove_approval': 'pi pi-check',
  'tosign_approval': 'pi pi-pencil',
  'traffic_light_green_toolbar_approval': 'pi pi-check-circle',
  'traffic_light_red_toolbar_approval': 'pi pi-times-circle',
  'traffic_light_yellow_toolbar_approval': 'pi pi-exclamation-circle',
  'cross_remove_approval_group': 'pi pi-times',
  'cross_remove_negotiator': 'pi pi-times',
  'sign': 'pi pi-pencil',
  'manual-sign': 'pi pi-pencil',

  // Tasks
  'task': 'pi pi-list',
  'task_in': 'pi pi-file-import',
  'task_out': 'pi pi-file-export',
  'task_control': 'pi pi-cog',
  'control_task': 'pi pi-cog',
  'control_play_blue': 'pi pi-play',
  'isDocumentRequering': 'pi pi-file',
  'comment': 'pi pi-comment',

  // Documents and files
  'attach': 'pi pi-paperclip',
  'attach-button': 'pi pi-paperclip',
  'draft': 'pi pi-file-edit',
  'templates': 'pi pi-file',
  'doc-excel-table': 'pi pi-file-excel',
  'book_open': 'pi pi-book',
  'blue_book': 'pi pi-book',
  'black_document': 'pi pi-file',
  'paper': 'pi pi-file',

  // Navigation and tree
  'treeCollapsed': 'pi pi-chevron-right',
  'treeExpanded': 'pi pi-chevron-down',
  'collapse': 'pi pi-chevron-up',
  'expand': 'pi pi-chevron-down',
  'triangle_open': 'pi pi-chevron-down',
  'triangle_close': 'pi pi-chevron-right',
  'triangle_down_gray': 'pi pi-chevron-down',
  'listbox_triangle': 'pi pi-chevron-down',

  // Date and time
  'date_chooser': 'pi pi-calendar',
  'swingdaterangeline': 'pi pi-calendar',
  'next_month': 'pi pi-angle-right',
  'previous_month': 'pi pi-angle-left',
  'next_year': 'pi pi-angle-double-right',
  'previous_year': 'pi pi-angle-double-left',
  'yearIcon': 'pi pi-calendar',
  'yearIcon_tiny': 'pi pi-calendar',

  // Actions and buttons
  'back_s': 'pi pi-arrow-left',
  'choise': 'pi pi-check',
  'choise_s': 'pi pi-check',
  'cancel_start': 'pi pi-times',
  'stop': 'pi pi-minus-circle',
  'run': 'pi pi-play',
  'loading': 'pi pi-spin pi-spinner',
  'empty': 'pi pi-circle',
  'default_fl': 'pi pi-file',

  // Special icons
  'barcode': 'pi pi-barcode',
  'door_open': 'pi pi-sign-in',
  'flash-drive': 'pi pi-usb',
  'keyboard_add': 'pi pi-keyboard',
  'scanner': 'pi pi-barcode',
  'Scaner': 'pi pi-barcode',
  'scan-button': 'pi pi-barcode',
  'hammer': 'pi pi-wrench',
  'bug': 'pi pi-bug',
  'history': 'pi pi-history',
  'clip': 'pi pi-paperclip',
  'cut': 'pi pi-cut',
  'paste_plain': 'pi pi-paste',

  // Tabs
  'tab_add': 'pi pi-plus',
  'tab_delete': 'pi pi-times',

  // Pagination
  'resultset_next': 'pi pi-angle-right',
  'resultset_previous': 'pi pi-angle-left',

  // Zoom
  'zoomIn-button': 'pi pi-search-plus',
  'zoomOut-button': 'pi pi-search-minus',

  // Rotate and scale
  'rotateLeft-button': 'pi pi-undo',
  'rotateRight-button': 'pi pi-redo',
  'scale-button': 'pi pi-arrows-alt',
  'crop-button': 'pi pi-crop',

  // Remove buttons
  'remove-button': 'pi pi-times',
  'remove-button-grey': 'pi pi-times',

  // Tags and flags
  'tag_blue': 'pi pi-tag',
  'tag_green': 'pi pi-tag',
  'tag_orange': 'pi pi-tag',
  'tag_pink': 'pi pi-tag',
  'tag_purple': 'pi pi-tag',
  'tag_red': 'pi pi-tag',
  'tag_yellow': 'pi pi-tag',
  'flag_blue': 'pi pi-flag',
  'flag_green': 'pi pi-flag',
  'flag_orange': 'pi pi-flag',
  'flag_pink': 'pi pi-flag',
  'flag_purple': 'pi pi-flag',
  'flag_red': 'pi pi-flag',
  'flag_yellow': 'pi pi-flag',

  // Status icons
  'on_approval': 'pi pi-clock',
  'on_registration': 'pi pi-file',
  'on_rework': 'pi pi-refresh',
  'incoming': 'pi pi-file-import',
  'outgoing': 'pi pi-file-export',
  'internal': 'pi pi-file',
  'recent': 'pi pi-clock',
  'review': 'pi pi-eye',

  // User status
  'user_status_main': 'pi pi-user',
  'user_status_not_main': 'pi pi-user-minus',
  'user_status_absent': 'pi pi-user-minus',
  'user_status_not_accessible': 'pi pi-user-times',

  // Special purpose icons
  'leaf': 'pi pi-file',
  'leaf_sharp': 'pi pi-file',
  'leaf_light': 'pi pi-file',
  'leaficon': 'pi pi-file',
  'megaphone': 'pi pi-volume-up',
  'megaphone_sharp': 'pi pi-volume-up',
  'megaphone_light': 'pi pi-volume-up',
  'pad_important': 'pi pi-exclamation-triangle',
  'pad_important_sharp': 'pi pi-exclamation-triangle',
  'pad_important_light': 'pi pi-exclamation-triangle',
  'pad_load_grey': 'pi pi-download',
  'pad_load_sharp': 'pi pi-download',
  'text_dropcaps': 'pi pi-file-edit',
  'script': 'pi pi-file',
  'script_code': 'pi pi-file',
  'buffer_plus': 'pi pi-plus',
  'buffer_plus_1': 'pi pi-plus',
  'got_message': 'pi pi-envelope',
  'balloon-white': 'pi pi-comment',
  'button_gradient': 'pi pi-circle',
  'shadow': 'pi pi-circle',
  'ancestors': 'pi pi-sitemap',
  'owner': 'pi pi-user',
  'orgGroup': 'pi pi-users',
  'originalSize': 'pi pi-arrows-alt',

  // Language and region
  'ru': 'pi pi-globe',
  'us': 'pi pi-globe',
  'uus': 'pi pi-globe',

  // Transport and logistics
  'wagon': 'pi pi-truck',
  'medic': 'pi pi-heart',
  'electro': 'pi pi-bolt',
  'cargo': 'pi pi-box',
  'cargo_invalid': 'pi pi-times-circle',
  'delivery': 'pi pi-truck',
  'delivery_invalid': 'pi pi-times-circle',

  // Address types
  'main_addr': 'pi pi-map-marker',
  'main_addr_invalid': 'pi pi-times-circle',
  'payer_addr': 'pi pi-map-marker',
  'payer_addr_invalid': 'pi pi-times-circle',
  'reg_addr': 'pi pi-map-marker',
  'reg_addr_invalid': 'pi pi-times-circle',
  'residence': 'pi pi-home',
  'residence_invalid': 'pi pi-times-circle',

  // Legal entities
  'jur': 'pi pi-building',
  'jur_invalid': 'pi pi-times-circle',
  'jur_egrul': 'pi pi-building',
  'jur_egrul_invalid': 'pi pi-times-circle',
  'foreign': 'pi pi-globe',
  'foreign_invalid': 'pi pi-times-circle',

  // Services
  'eis': 'pi pi-server',
  'pgu': 'pi pi-globe',
  'rkn': 'pi pi-shield',
  'rfi': 'pi pi-file',
  'medo': 'pi pi-envelope',
  'postrus': 'pi pi-envelope',
  'evrazes': 'pi pi-globe',
  'shluse': 'pi pi-link',

  // Status indicators
  'aja': 'pi pi-check-circle',
  'aja_invalid': 'pi pi-times-circle',
  'el': 'pi pi-check-circle',
  'el_invalid': 'pi pi-times-circle',
  'fact': 'pi pi-check-circle',
  'fact_invalid': 'pi pi-times-circle',
  'mail_invalid': 'pi pi-times-circle',
  'mail_add_invalid': 'pi pi-times-circle',

  // Editable states
  'editable': 'pi pi-pencil',
  'uneditable': 'pi pi-lock',

  // Status indicators with size variants (red-du-small, green-du-small, etc.)
  'red-du-small': 'pi pi-circle-fill',
  'red-du-medium': 'pi pi-circle-fill',
  'red-du-big': 'pi pi-circle-fill',
  'green-du-small': 'pi pi-circle-fill',
  'green-du-medium': 'pi pi-circle-fill',
  'green-du-big': 'pi pi-circle-fill',
  'yellow-du-small': 'pi pi-circle-fill',
  'yellow-du-medium': 'pi pi-circle-fill',
  'yellow-du-big': 'pi pi-circle-fill',
  'grey-du-small': 'pi pi-circle',
  'grey-du-medium': 'pi pi-circle',
  'grey-du-big': 'pi pi-circle',

  'add_s.gif': 'pi pi-plus',
  'arrow_divide_up.png': 'pi pi-arrow-up',
  'arrow_refresh.png': 'pi pi-refresh',
  'asterisk_orange.png': 'pi pi-star',
  'cancel.gif': 'pi pi-times',
  'disk.png': 'pi pi-save',
  'next_s.gif': 'pi pi-angle-right',
  'reload.png': 'pi pi-refresh',
  'orgGroup.png': 'pi pi-users',
  'email_tick.png': 'pi pi-envelope',
  'GO.png': 'pi pi-play',
  'Zagoranie.png': 'pi pi-bolt',

  // Default fallback icon
  'default': 'pi pi-question-circle',
}

/**
 * Явное сопоставление PrimeIcons (без fuzzy-match и без default).
 * Для цепочки Prime → Swing PNG → default используйте resolvePlatformIcon.
 */
export function getExplicitPrimeIcon(externalIconName: string): string | undefined {
  if (!externalIconName) return undefined

  const nameWithoutExt = externalIconName.replace(/\.(png|gif|jpg|jpeg|svg)$/i, '')

  if (iconMapper[externalIconName]) {
    return iconMapper[externalIconName]
  }
  if (iconMapper[nameWithoutExt]) {
    return iconMapper[nameWithoutExt]
  }

  return undefined
}

/**
 * Получает имя иконки PrimeIcons по внешнему имени
 */
export function getPrimeIcon(externalIconName: string): string {
  const explicit = getExplicitPrimeIcon(externalIconName)
  if (explicit) return explicit

  if (!externalIconName) return iconMapper.default

  const nameWithoutExt = externalIconName.replace(/\.(png|gif|jpg|jpeg|svg)$/i, '')

  const foundKey = Object.keys(iconMapper).find(
    (key) =>
      key !== 'default' &&
      (nameWithoutExt.toLowerCase().includes(key.toLowerCase()) ||
        key.toLowerCase().includes(nameWithoutExt.toLowerCase())),
  )

  return foundKey ? iconMapper[foundKey] : iconMapper.default
}

/**
 * Проверяет, существует ли явное сопоставление в iconMapper
 */
export function hasIcon(externalIconName: string): boolean {
  return Boolean(getExplicitPrimeIcon(externalIconName))
}

/**
 * Получает иконку на основе типа файла (расширения)
 * @param fileName - имя файла с расширением
 * @returns класс иконки PrimeIcons
 */
export function getFileTypeIcon(fileName?: string | null): string {
  if (!fileName) return 'pi pi-file'

  const lowerFileName = fileName.toLowerCase()

  // Documents
  if (lowerFileName.endsWith('.pdf')) return 'pi pi-file-pdf'
  if (lowerFileName.match(/\.(doc|docx)$/)) return 'pi pi-file-word'
  if (lowerFileName.match(/\.(xls|xlsx)$/)) return 'pi pi-file-excel'
  if (lowerFileName.match(/\.(ppt|pptx)$/)) return 'pi pi-file'
  if (lowerFileName.match(/\.(txt|log)$/)) return 'pi pi-file'

  // Images
  if (lowerFileName.match(/\.(jpg|jpeg|png|gif|bmp|svg|webp)$/)) return 'pi pi-image'

  // Archives
  if (lowerFileName.match(/\.(zip|rar|7z|tar|gz|bz2)$/)) return 'pi pi-box'

  // Code files
  if (lowerFileName.match(/\.(js|ts|jsx|tsx|vue|java|py|rb|php|css|scss|html)$/)) return 'pi pi-code'

  // Video
  if (lowerFileName.match(/\.(mp4|avi|mov|wmv|flv|mkv|webm)$/)) return 'pi pi-video'

  // Audio
  if (lowerFileName.match(/\.(mp3|wav|ogg|flac|aac)$/)) return 'pi pi-volume-up'

  // Default
  return 'pi pi-file'
}

export default {
  iconMapper,
  getExplicitPrimeIcon,
  getPrimeIcon,
  hasIcon,
  getFileTypeIcon,
}
